import React from 'react';
import { ButtonBase } from '@mui/material';
import SymbolCard from './components/SymbolCard.tsx';

const Arrangement = (props) => {
    const { symbol, orientations, checkAnswer, isMobile } = props;

    let style = { padding: '2em' };
    if (isMobile) style = { padding: '1em' };

    const textSize = isMobile ? 'h2' : 'h1';
    return (
        <>
            <div style={style}>
                <ButtonBase
                    onClick={(event) => {
                        checkAnswer(symbol, orientations[0]);
                    }}
                >
                    <SymbolCard
                        symbol={symbol}
                        orientation={orientations[0]}
                        textStyle={textSize}
                    />
                </ButtonBase>
                {isMobile ? <div style={style} /> : <span style={style} />}
                <ButtonBase
                    onClick={(event) => {
                        checkAnswer(symbol, orientations[1]);
                    }}
                >
                    <SymbolCard
                        symbol={symbol}
                        orientation={orientations[1]}
                        textStyle={textSize}
                    />
                </ButtonBase>
            </div>
            <div style={style}>
                <ButtonBase
                    onClick={(event) => {
                        checkAnswer(symbol, orientations[2]);
                    }}
                >
                    <SymbolCard
                        symbol={symbol}
                        orientation={orientations[2]}
                        textStyle={textSize}
                    />
                </ButtonBase>
                {isMobile ? <div style={style} /> : <span style={style} />}
                <ButtonBase
                    onClick={(event) => {
                        checkAnswer(symbol, orientations[3]);
                    }}
                >
                    <SymbolCard
                        symbol={symbol}
                        orientation={orientations[3]}
                        textStyle={textSize}
                    />
                </ButtonBase>
            </div>
        </>
    );
};

export default Arrangement;
